import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {B2bRegistrationModule} from './b2b-registration/b2b-registration.module';
import {B2iRegistrationModule} from './b2i-registration/b2i-registration.module';
import {CompanySelectionModule} from './company-selection/company-selection.module';
import {CustomerNameModule} from './customer-name/customer-name.module';

@NgModule({
  imports: [
    CommonModule,
    B2bRegistrationModule,
    B2iRegistrationModule,
    CompanySelectionModule,
    CustomerNameModule,
  ],
})
export class RegistrationModule {
}
